import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import ThemeLogo from '@/components/ThemeLogo.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('ThemeLogo', ThemeLogo)
